import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import scheduleData from 'weekly_matchups.json';
import md5 from 'blueimp-md5';

const MNGLTeeSchedule = () => {
  const [teeTimes, setTeeTimes] = useState({});
  const [webResults, setWebResults] = useState({});

  const thisWeek = getCurrentWeekNumber();
  // Fetch tee times
  useEffect(() => {
    fetch('https://api.threes.day/mngl/tees')
      .then(res => res.json())
      .then(data => {
        if (data.teeTimes && Object.keys(data.teeTimes).length > 0) {
          console.log('tee times', data)
          setTeeTimes(data.teeTimes);
        }
      })
      .catch(console.error);
      fetch('https://api.threes.day/mngl/web-results')
      .then(res => res.json())
      .then(data => {
        const quotaMap = {};
        data.forEach(item => {
          quotaMap[item.name] = item;
        });
        setWebResults(quotaMap);
      })
      .catch(console.error);
  }, []);

  // Build maps for week 1
  const week1 = scheduleData.find(w => w.week === thisWeek);

  // shortName -> full player object map
  const fullMap = {};
  // shortName -> opponent object map
  const oppMap = {};

  week1.matchups.forEach(match => {
    match.players.forEach(p => {
      var players = extractAndKey(p, 'name')
      var player1 = players[0] || {name:" "}
      var player2 = players[1] || {name:" "}

      fullMap[getShortName(player1.name)] = player1;
      oppMap[getShortName(player1.name)] = player2;
      fullMap[getShortName(player2.name)] = player2;
      oppMap[getShortName(player2.name)] = player1;
      
    });
  });

  function getCurrentWeekNumber(now = new Date()) {
    // Base = May 1 2025 (JS months are zero‑based)
    const base = new Date(2025, 4, 1);
    const msPerWeek = 7 * 24 * 60 * 60 * 1000;
  
    // Calculate how many full weeks have passed since base
    const delta = now.getTime() - base.getTime();
    // floor for dates >= base, otherwise clamp to 0 so you never drop below week 3
    const weeksSince = delta >= 0
      ? Math.floor(delta / msPerWeek)
      : 0;
  
    return 3 + weeksSince;
  }

  function extractAndKey(obj, keyProp = 'id') {
    // 1) remove primitives: keep only value-objects
    const objectEntries = Object
      .entries(obj)
      .filter(([_, v]) => v !== null && typeof v === 'object');
  
    // 2) get an array of those objects
    const items = objectEntries.map(([_, v]) => v);
  /*
    // 3) build a lookup keyed by `keyProp`
    const lookup = items.reduce((acc, item) => {
      if (keyProp in item) acc[item[keyProp]] = item;
      return acc;
    }, {});
  */
    return items;
  }

  // helper to get short name from fullName
  function getShortName(fullName) {
    if(!fullName || typeof fullName !== 'string') return ""
    const [last, first] = fullName.split(',').map(s => s.trim());
    if (!first || !last) return fullName;
    return `${first} ${last.charAt(0)}`;
  }

  // sort time strings 3:00 -> 5:00
  const times = Object.keys(teeTimes).sort((a, b) => {
    const [ah, am] = a.split(':').map(Number);
    const [bh, bm] = b.split(':').map(Number);
    return ah * 60 + am - (bh * 60 + bm);
  });

  function PlayerCard({ player }) {
    const dynamicPlayer = webResults[player.name] || player.quota;
    console.log('dq', dynamicPlayer)
    return (
      <div className="text-center">
        <a href={`profile?phone=${player.phone}`}>
          <Avatar email={player.email} name={player.name}/>
        </a>
        <div className="mt-2 fw-bold" style={{    fontSize:"14px",fontWeight:"bold",textOverflow:"clip"}}>{player.name}</div>
        <div className="text-muted" style={{ fontSize: 12 }}>
          <div style={{display:'none'}}><a href={`mailto:${player.email}`}>{player.email}</a></div>
          <div style={{color:"#444"}}><b>Quota: {dynamicPlayer.current_quota}</b></div>
          <div>Last: {dynamicPlayer.score} - Q: {dynamicPlayer.match_quota}</div>
          <div>Avg: {dynamicPlayer.average_score} - Wins: {dynamicPlayer.win_percent}</div>
        </div>
      </div>
    );
  }

  function Avatar({ email, name = "", size = 80 }) {
    const hash = md5(email.trim().toLowerCase());
    const urls = [
      //`https://www.gravatar.com/avatar/${hash}?s=${size}&d=404`,
      `https://avatar.clearbit.com/${encodeURIComponent(email)}?size=${size}`,
      `https://api.dicebear.com/9.x/initials/svg?seed=${(name.split(","))[1]+(name.split(","))[0]}&backgroundColor=b6e3f4,c0aede,d1d4f9&size=${size}`
      //`https://avatars.dicebear.com/api/identicon/${encodeURIComponent(email)}.svg`,
    ];
  
    const [src, setSrc] = useState(urls[0]);
  
    return (
      <img
        src={src}
        width={size}
        height={size}
        alt="avatar"
        onError={() => {
          const idx = urls.indexOf(src);
          if (idx < urls.length - 1) setSrc(urls[idx + 1]);
        }}
      />
    );
  }

  return (
    <div className="container py-4">
      <h3 className="mb-4">Tee Times (Week {thisWeek})</h3>
      {times.map(time => {
        const entries = teeTimes[time] || [];
        // accumulate players including opponents
        const players = [];
        entries.forEach(e => {
          const short = e.player.replaceAll(".", "").replaceAll("Thomas", "Tom");
          // signed up
          if (e.spots == 2 && oppMap[short] && fullMap[short]) fullMap[short].opp = oppMap[short];

          if (fullMap[short]) players.push(fullMap[short]);
          // opponent

        });
        // remove duplicates by name
        const unique = Array.from(
          new Map(players.map(p => [p.name, p])).values()
        );

        return (
          <div
            key={time}
            className="card mb-3"
            style={{ backgroundColor: 'lightgrey', fontSize: 10 }}
          >
            <div
              className="card-header text-center"
              style={{ fontSize: 14, fontWeight: 'bold', backgroundColor: 'darkgray' }}
            >
              {time}
            </div>
            <div className="card-body">
              {/*
                If any of your `unique` items have an `opp`, render them
                as head‑to‑head VS rows; otherwise lay everyone out in 2×2 grid.
              */}
              {unique.some(p => p.opp && Object.keys(p.opp).length) ? (
                unique.map(player =>
                  player.opp && Object.keys(player.opp).length ? (
                    <div
                      key={player.name}
                      className="d-flex align-items-center justify-content-center mb-3 mt-3"
                    >
                      <PlayerCard player={player} />
                      <div className="mx-3 fw-bold">VS</div>
                      <PlayerCard player={player.opp} />
                    </div>
                  ) : null
                )
              ) : (
                <div
                  className="d-grid"
                  style={{
                    gridTemplateColumns: '1fr 1fr',
                    gridAutoRows: 'auto',
                    gap: '1rem',
                  }}
                >
                  {unique.map(player => (
                    <PlayerCard key={player.name} player={player} />
                  ))}
                  {(unique.length==0)?<>
                    <div
                      className="d-flex align-items-center justify-content-center mb-3 mt-3"
                    >
                    <a className="text-secondary" target="native-sheet" href="http://www.mngl.org/weekly-matches/?sheet_id=110&task_id=4329&date=2025-05-07"><b>Sign up</b></a>
                    </div>
                  </>:null}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MNGLTeeSchedule;
